import { HOMEPAGE } from '@/config/router';
import { isEmpty } from 'ramda';
import { useEffect, useState } from 'react';
import { type Params, useMatches, useOutlet } from 'react-router';

import { useFlattenedRoutes } from './use-flattened-routes';
import { useRouter } from './use-router';

import type { RouteMeta } from '#/router';

export function useCurrentRouteMeta() {
  // const pathname = usePathname();
  const { push } = useRouter();

  const children = useOutlet();

  const matches = useMatches();

  const flattenedRoutes = useFlattenedRoutes();

  const [currentRouteMeta, setCurrentRouteMeta] = useState<RouteMeta>();

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    const lastRoute = matches.at(-1);
    if (!lastRoute) return;

    const { pathname, params } = lastRoute;
    const matchedRouteMeta = flattenedRoutes.find((item) => {
      const replacedKey = replaceDynamicParams(item.key, params);
      return replacedKey === pathname || `${replacedKey}/` === pathname;
    });

    if (matchedRouteMeta) {
      matchedRouteMeta.outlet = children;
      if (!isEmpty(params)) {
        matchedRouteMeta.params = params;
      }
      setCurrentRouteMeta({ ...matchedRouteMeta });
    } else {
      push(HOMEPAGE);
    }
  }, [matches]);

  return currentRouteMeta;
}

/**
 * replace `user/:id`  to `/user/1234512345`
 */
export const replaceDynamicParams = (menuKey: string, params: Params<string>) => {
  let replacedPathName = menuKey;

  const paramNames = menuKey.match(/:\w+/g);

  if (paramNames) {
    for (const paramName of paramNames) {
      const paramKey = paramName.slice(1);
      if (!params[paramKey]) continue;

      replacedPathName = replacedPathName.replace(paramName, params[paramKey]);
    }
  }

  return replacedPathName;
};
